// src/lib/s3Upload.js
export async function initiateUploads(files) {
    const r = await fetch('/api/prowadzacy/pytania/files/initiate', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
        },
        body: JSON.stringify({ files })
    });
    if (!r.ok) {
        const t = await r.json().catch(() => ({}));
        throw new Error(t.blad || 'Błąd inicjowania uploadów (presigned PUT)');
    }
    return r.json();
}

export async function putToS3(upload, file) {
    const { url, headers, method } = upload || {};
    const res = await fetch(url, {
        method: method || 'PUT',
        headers: { ...(headers || {}), 'Content-Type': file.type },
        body: file
    });
    if (!res.ok) throw new Error('Błąd wysyłki pliku na S3');
}

export async function signGet(key) {
    const r = await fetch(`/api/prowadzacy/media/sign?key=${encodeURIComponent(key)}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token') || ''}` }
    });
    if (!r.ok) throw new Error('Błąd tworzenia presigned GET');
    return r.json(); // { url, expiresIn }
}

export async function uploadAllPhysicalFiles(physicalFiles) {
    if (physicalFiles.length === 0) {
        return { questionFilesMeta: [], optionMediaByIndex: new Map() };
    }
    const init = await initiateUploads(
        physicalFiles.map(p => ({
            filename: p.filename,
            contentType: p.contentType,
            sizeBytes: p.size,
            scope: p.scope,
            optionIndex: p.optionIndex ?? null,
            questionIndex: p.questionIndex ?? null,
        }))
    );
    await Promise.all(
        init.uploads.map(async (u, idx) => {
            const candidate = physicalFiles.find(p =>
                p.scope === u.scope &&
                (p.optionIndex ?? null) === (u.optionIndex ?? null) &&
                p.filename &&
                p.size
            ) || physicalFiles[idx];
            if (!candidate) throw new Error('Nie udało się dopasować pliku do presignu');
            await putToS3(u.upload, candidate.file);
        })
    );
    const questionFilesMeta = [];
    const optionMediaByIndex = new Map();
    init.uploads.forEach((u, i) => {
        const pf = physicalFiles.find(p =>
            p.scope === u.scope &&
            (p.optionIndex ?? null) === (u.optionIndex ?? null) &&
            p.filename &&
            p.size
        ) || physicalFiles[i];
        if (!pf) return;
        const meta = { key: u.key, content_type: pf.contentType, size_bytes: pf.size };
        if (u.scope === 'question') {
            questionFilesMeta.push(meta);
        } else if (u.scope === 'option' && typeof (pf.optionIndex) === 'number') {
            optionMediaByIndex.set(pf.optionIndex, meta);
        }
    });
    return { questionFilesMeta, optionMediaByIndex };
}
